import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["switch", "colorfulIcon", "monochromeIcon"]
  static values = {
    url: { type: String, default: "" },
    enabled: { type: Boolean, default: false }
  }

  connect() {
    this.onPageLoad = this.onPageLoad.bind(this)
    document.addEventListener("turbo:load", this.onPageLoad)
    document.addEventListener("turbolinks:load", this.onPageLoad)
    this.syncIcons()
    this.onPageLoad()
  }

  disconnect() {
    document.removeEventListener("turbo:load", this.onPageLoad)
    document.removeEventListener("turbolinks:load", this.onPageLoad)
  }

  onPageLoad() {
    if (document.body.classList.contains("mono-style")) {
      this.applyCrudMarkers()
    } else {
      this.removeCrudMarkers()
    }
  }

  toggle(event) {
    this.setEnabled(event.target.checked)
  }

  selectColorful(event) {
    event.preventDefault()
    this.setEnabled(false)
  }

  selectMonochrome(event) {
    event.preventDefault()
    this.setEnabled(true)
  }

  setEnabled(enabled) {
    if (!this.urlValue) return
    if (enabled === this.enabledValue) {
      if (this.hasSwitchTarget) {
        this.switchTarget.checked = enabled
      }
      this.syncIcons()
      return
    }

    if (this.hasSwitchTarget) {
      this.switchTarget.checked = enabled
    }

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-CSRF-Token": csrfToken
      },
      body: JSON.stringify({ user: { mono_style: enabled } }),
      credentials: "same-origin"
    }).then(response => {
      if (!response.ok) {
        if (this.hasSwitchTarget) {
          this.switchTarget.checked = !enabled
        }
        return
      }

      document.body.classList.toggle("mono-style", enabled)
      this.enabledValue = enabled
      this.syncIcons()

      if (enabled) {
        this.applyCrudMarkers()
      } else {
        this.removeCrudMarkers()
      }
    }).catch(() => {
      if (this.hasSwitchTarget) {
        this.switchTarget.checked = !enabled
      }
    })
  }

  syncIcons() {
    const enabled = this.hasSwitchTarget ? this.switchTarget.checked : this.enabledValue

    if (this.hasColorfulIconTarget) {
      this.colorfulIconTarget.classList.toggle("is-active", !enabled)
      this.colorfulIconTarget.setAttribute("aria-pressed", (!enabled).toString())
    }

    if (this.hasMonochromeIconTarget) {
      this.monochromeIconTarget.classList.toggle("is-active", enabled)
      this.monochromeIconTarget.setAttribute("aria-pressed", enabled.toString())
    }
  }

  applyCrudMarkers() {
    document.querySelectorAll("a.btn-success, button.btn-success, input.btn-success").forEach(el => {
      el.classList.add("mono-crud")
    })

    document.querySelectorAll("a.btn-danger, button.btn-danger, input.btn-danger").forEach(el => {
      el.classList.add("mono-crud")
    })

    document.querySelectorAll("form").forEach(form => {
      const methodField = form.querySelector('input[name="_method"]')
      const method = (methodField?.value || form.getAttribute("method") || "get").toLowerCase()

      if (method === "get") return

      form.querySelectorAll('button[type="submit"], input[type="submit"]').forEach(el => {
        if (el.classList.contains("btn-primary") ||
            el.classList.contains("btn-success") ||
            el.classList.contains("btn-danger") ||
            el.classList.contains("btn-warning")) {
          el.classList.add("mono-crud")
        }
      })
    })
  }

  removeCrudMarkers() {
    document.querySelectorAll(".mono-crud").forEach(el => el.classList.remove("mono-crud"))
  }
}
